export const bookingsType = {
  GET_ORDERS: "GET_ORDERS",
  REQUEST_BOOKING: "REQUEST_BOOKING",
  REQUEST_BOOKING_DONE: "REQUEST_BOOKING_DONE",
};
